(() => {
  if (customElements.get('sh24-product-datasheet')) return;
  customElements.define('sh24-product-datasheet', class extends HTMLElement {
    static get observedAttributes() { return ['data-placement']; }
    attributeChangedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.place(); });
    }
    connectedCallback() {
      queueMicrotask(() => { if (this.isConnected) this.place(); });
    }
    place() {
      const placement = this.dataset.placement;
      if (placement === 'block') {
        if (this.sourceMarker?.isConnected) {
          if (this.previousSibling !== this.sourceMarker) this.sourceMarker.parentNode.insertBefore(this, this.sourceMarker.nextSibling);
          this.releaseRow();
          this.classList.remove('sh24-datasheet--above-price');
          this.restoreSourceWrapper();
        }
        return;
      }
      if (!['price', 'price_before', 'above_price'].includes(placement)) return;
      const price = document.getElementById('price-' + this.dataset.sectionId);
      const section = this.closest('.shopify-section');
      if (!price || !section || price.closest('.shopify-section') !== section || price.contains(this)) return;
      if (placement === 'above_price' && this.nextElementSibling === price && this.parentElement === price.parentElement && !this.parentElement.classList.contains('sh24-price-datasheet-row')) return;
      if (this.parentElement?.classList.contains('sh24-price-datasheet-row')) {
        if (placement === 'price_before' && this.nextElementSibling === price) return;
        if (placement === 'price' && this.previousElementSibling === price) return;
      }
      if (!this.sourceMarker) {
        this.sourceMarker = document.createComment('SH24 datasheet block position');
        this.parentNode.insertBefore(this.sourceMarker, this);
      }
      const sourceWrapper = this.parentElement;
      if (placement === 'above_price') {
        const priceRow = price.parentElement;
        if (priceRow.classList.contains('sh24-price-datasheet-row')) {
          priceRow.parentNode.insertBefore(this, priceRow);
          this.releaseRow();
        } else {
          price.parentNode.insertBefore(this, price);
        }
        this.classList.add('sh24-datasheet--above-price');
      } else {
        let row = price.parentElement;
        if (!row.classList.contains('sh24-price-datasheet-row')) {
          row = document.createElement('div');
          row.className = 'sh24-price-datasheet-row';
          price.parentNode.insertBefore(row, price);
          row.appendChild(price);
        }
        this.row = row;
        this.classList.remove('sh24-datasheet--above-price');
        if (placement === 'price_before') row.insertBefore(this, price);
        else row.appendChild(this);
      }
      if (sourceWrapper?.classList.contains('custom-liquid-right') && !sourceWrapper.children.length && !sourceWrapper.textContent.trim()) {
        this.sourceWrapper = sourceWrapper;
        this.sourceWrapperWasHidden = sourceWrapper.hidden;
        sourceWrapper.hidden = true;
      }
    }
    releaseRow() {
      if (this.row?.isConnected && !this.row.querySelector('sh24-product-datasheet')) {
        this.row.replaceWith(...this.row.childNodes);
        this.row = null;
      }
    }
    restoreSourceWrapper() {
      if (this.sourceWrapper?.isConnected) this.sourceWrapper.hidden = this.sourceWrapperWasHidden;
    }
    disconnectedCallback() {
      queueMicrotask(() => {
        if (this.isConnected) return;
        this.releaseRow();
        this.sourceMarker?.remove();
        this.sourceMarker = null;
        this.restoreSourceWrapper();
      });
    }
  });
})();
